var escape = require("../../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#header[data-v-54f11916]{padding-top:60px;background:url(" + escape(require("../../../../images/index-bg-repeat.png")) + ") repeat-x;background-size:20px 450px;width:100%;height:470px;left:0}#header div[data-v-54f11916]{text-align:center}.my-avatar[data-v-54f11916]{border-radius:500rem;border:2px solid #e8e8e8;height:100px;width:100px}.intro[data-v-54f11916]{font-size:16px;margin-top:10px}.nick[data-v-54f11916]{margin-top:5px;font-size:24px;font-style:italic}.follow_me[data-v-54f11916]{margin-top:20px;-ms-flex-line-pack:center;align-content:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-54f11916","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/web/components/index/header.vue
// module id = 93
// module chunks = 1